import { render, staticRenderFns } from "./fullscreen-dialog.vue?vue&type=template&id=e208dc44"
import script from "./fullscreen-dialog.vue?vue&type=script&lang=js"
export * from "./fullscreen-dialog.vue?vue&type=script&lang=js"
import style0 from "./fullscreen-dialog.vue?vue&type=style&index=0&id=e208dc44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports